
import postcssStyledJsxUrlLoader_0 from '../fonts/Graphik-Regular.woff2';
import postcssStyledJsxUrlLoader_1 from '../fonts/Graphik-Regular.woff';
import postcssStyledJsxUrlLoader_2 from '../fonts/Graphik-Bold.woff2';
import postcssStyledJsxUrlLoader_3 from '../fonts/Graphik-Bold.woff';
import postcssStyledJsxUrlLoader_4 from '../fonts/Graphik-RegularItalic.woff2';
import postcssStyledJsxUrlLoader_5 from '../fonts/Graphik-RegularItalic.woff';
import postcssStyledJsxUrlLoader_6 from '../fonts/Graphik-Semibold.woff2';
import postcssStyledJsxUrlLoader_7 from '../fonts/Graphik-Semibold.woff';
import postcssStyledJsxUrlLoader_8 from '../fonts/Graphik-SemiboldItalic.woff2';
import postcssStyledJsxUrlLoader_9 from '../fonts/Graphik-SemiboldItalic.woff';
import postcssStyledJsxUrlLoader_10 from '../fonts/Graphik-BoldItalic.woff2';
import postcssStyledJsxUrlLoader_11 from '../fonts/Graphik-BoldItalic.woff';
import postcssStyledJsxUrlLoader_12 from '../fonts/SmileScript.woff2';
import postcssStyledJsxUrlLoader_13 from '../fonts/SmileScript.woff';
import postcssStyledJsxUrlLoader_14 from '../fonts/SmileScript-40.woff2';
import postcssStyledJsxUrlLoader_15 from '../fonts/SmileScript-40.woff2';
import postcssStyledJsxUrlLoader_16 from '../fonts/SmileScript-60.woff2';
import postcssStyledJsxUrlLoader_17 from '../fonts/SmileScript-60.woff2';
import postcssStyledJsxUrlLoader_18 from '../fonts/Graphik-Regular.woff2';
import postcssStyledJsxUrlLoader_19 from '../fonts/Graphik-Regular.woff';
import postcssStyledJsxUrlLoader_20 from '../fonts/Honey-BoldBanner.woff2';
import postcssStyledJsxUrlLoader_21 from '../fonts/Honey-BoldBanner.woff';
import postcssStyledJsxUrlLoader_22 from '../fonts/Honey-ExtraboldBanner.woff2';
import postcssStyledJsxUrlLoader_23 from '../fonts/Honey-ExtraboldBanner.woff';
import postcssStyledJsxUrlLoader_24 from '../fonts/IntercomBrand-Medium.woff2';
import postcssStyledJsxUrlLoader_25 from '../fonts/IntercomBrand-Medium.woff';
import postcssStyledJsxUrlLoader_26 from '../fonts/tt_norms_pro_thin.woff';
import postcssStyledJsxUrlLoader_27 from '../fonts/tt_norms_pro_thin.woff';
import postcssStyledJsxUrlLoader_28 from '../fonts/tt_norms_pro_thin_italic.woff';
import postcssStyledJsxUrlLoader_29 from '../fonts/tt_norms_pro_thin_italic.woff';
import postcssStyledJsxUrlLoader_30 from '../fonts/tt_norms_pro_extralight.woff';
import postcssStyledJsxUrlLoader_31 from '../fonts/tt_norms_pro_extralight.woff';
import postcssStyledJsxUrlLoader_32 from '../fonts/tt_norms_pro_extralight_italic.woff';
import postcssStyledJsxUrlLoader_33 from '../fonts/tt_norms_pro_extralight_italic.woff';
import postcssStyledJsxUrlLoader_34 from '../fonts/tt_norms_pro_light.woff';
import postcssStyledJsxUrlLoader_35 from '../fonts/tt_norms_pro_light.woff';
import postcssStyledJsxUrlLoader_36 from '../fonts/tt_norms_pro_light_italic.woff';
import postcssStyledJsxUrlLoader_37 from '../fonts/tt_norms_pro_light_italic.woff';
import postcssStyledJsxUrlLoader_38 from '../fonts/tt_norms_pro_normal.woff';
import postcssStyledJsxUrlLoader_39 from '../fonts/tt_norms_pro_normal.woff';
import postcssStyledJsxUrlLoader_40 from '../fonts/tt_norms_pro_normal_italic.woff';
import postcssStyledJsxUrlLoader_41 from '../fonts/tt_norms_pro_normal_italic.woff';
import postcssStyledJsxUrlLoader_42 from '../fonts/tt_norms_pro_medium.woff';
import postcssStyledJsxUrlLoader_43 from '../fonts/tt_norms_pro_medium.woff';
import postcssStyledJsxUrlLoader_44 from '../fonts/tt_norms_pro_medium_italic.woff';
import postcssStyledJsxUrlLoader_45 from '../fonts/tt_norms_pro_medium_italic.woff';
import postcssStyledJsxUrlLoader_46 from '../fonts/tt_norms_pro_demibold.woff';
import postcssStyledJsxUrlLoader_47 from '../fonts/tt_norms_pro_demibold.woff';
import postcssStyledJsxUrlLoader_48 from '../fonts/tt_norms_pro_demibold_italic.woff';
import postcssStyledJsxUrlLoader_49 from '../fonts/tt_norms_pro_demibold_italic.woff';
import postcssStyledJsxUrlLoader_50 from '../fonts/tt_norms_pro_bold.woff';
import postcssStyledJsxUrlLoader_51 from '../fonts/tt_norms_pro_bold.woff';
import postcssStyledJsxUrlLoader_52 from '../fonts/tt_norms_pro_bold_italic.woff';
import postcssStyledJsxUrlLoader_53 from '../fonts/tt_norms_pro_bold_italic.woff';
import postcssStyledJsxUrlLoader_54 from '../fonts/tt_norms_pro_extrabold.woff';
import postcssStyledJsxUrlLoader_55 from '../fonts/tt_norms_pro_extrabold.woff';
import postcssStyledJsxUrlLoader_56 from '../fonts/tt_norms_pro_extrabold_italic.woff';
import postcssStyledJsxUrlLoader_57 from '../fonts/tt_norms_pro_extrabold_italic.woff';
import postcssStyledJsxUrlLoader_58 from '../fonts/tt_norms_pro_black.woff';
import postcssStyledJsxUrlLoader_59 from '../fonts/tt_norms_pro_black.woff';
import postcssStyledJsxUrlLoader_60 from '../fonts/tt_norms_pro_black_italic.woff';
import postcssStyledJsxUrlLoader_61 from '../fonts/tt_norms_pro_black_italic.woff';
import postcssStyledJsxUrlLoader_62 from '../fonts/tt_norms_pro_extrablack.woff';
import postcssStyledJsxUrlLoader_63 from '../fonts/tt_norms_pro_extrablack.woff';
import postcssStyledJsxUrlLoader_64 from '../fonts/tt_norms_pro_extrablack_italic.woff';
import postcssStyledJsxUrlLoader_65 from '../fonts/tt_norms_pro_extrablack_italic.woff';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_0}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_1}") format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_2}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_3}") format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_4}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_5}") format('woff');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_6}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_7}") format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_8}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_9}") format('woff');
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: 'Graphik';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_10}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_11}") format('woff');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'Smile Script';
  src: url("${postcssStyledJsxUrlLoader_12}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_13}") format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  font-feature-settings: 'liga' 1;
}

@font-face {
  font-family: 'Smile Script';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_14}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_15}") format('woff');
  font-weight: 800;
  font-style: normal;
  font-feature-settings: 'liga' 1;
}

@font-face {
  font-family: 'Smile Script';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_16}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_17}") format('woff');
  font-weight: 800;
  font-style: normal;
  font-feature-settings: 'liga' 1;
}

/*
  Needed to only apply "Honey Bold Banner" to texts with bold or bold+
  font-weight and use Graphik Regular for all non-bold texts
*/
@font-face {
  font-family: 'Honey Bold Banner';
  src: url("${postcssStyledJsxUrlLoader_18}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_19}") format('woff');
  font-display: block;
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Honey Bold Banner';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_20}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_21}") format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Honey Bold Banner';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_22}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_23}") format('woff');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Intercom Brand';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_24}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_25}") format('woff');
  font-weight: 500;
  font-style: normal;
}

/* BRP 2022 */

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_26}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_27}") format('woff');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_28}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_29}") format('woff');
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_30}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_31}") format('woff');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_32}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_33}") format('woff');
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_34}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_35}") format('woff');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_36}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_37}") format('woff');
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_38}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_39}") format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_40}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_41}") format('woff');
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_42}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_43}") format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_44}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_45}") format('woff');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_46}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_47}") format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_48}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_49}") format('woff');
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_50}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_51}") format('woff');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_52}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_53}") format('woff');
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_54}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_55}") format('woff');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_56}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_57}") format('woff');
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_58}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_59}") format('woff');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_60}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_61}") format('woff');
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_62}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_63}") format('woff');
  font-weight: 950;
  font-style: normal;
}

@font-face {
  font-family: 'TT Norms Pro';
  font-display: block;
  src: url("${postcssStyledJsxUrlLoader_64}") format('woff2'),
    url("${postcssStyledJsxUrlLoader_65}") format('woff');
  font-weight: 950;
  font-style: italic;
}
`